<template>
    <VcMdEditor
        v-if="markdownContent"
        :model-value="markdownContent"
        readonly
        hide-toolbar
        :min-height="0"
        class="ai-summary-list-viewer"
        :class="`ai-summary-list-viewer--${variant}`"
    />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { VcMdEditor } from '@voicenter-team/voicenter-ui-plus'

export interface AiSummaryListItem {
    label: string
    value?: string | number
}

const props = defineProps<{
    variant: 'numbered' | 'bullets'
    items: AiSummaryListItem[] | string[]
}>()

const normalizedItems = computed<AiSummaryListItem[]>(() => {
    return props.items.map(item => typeof item === 'string' ? { label: item } : item)
})

const markdownContent = computed(() => {
    if (!normalizedItems.value.length) return ''

    return normalizedItems.value
        .map((item, index) => {
            const prefix = props.variant === 'numbered' ? `${index + 1}.` : '-'
            const suffix = props.variant === 'numbered' && item.value != null && item.value !== ''
                ? ` ~~${item.value}~~`
                : ''
            return `${prefix} ${item.label}${suffix}`
        })
        .join('\n')
})
</script>

<style lang="scss">
.ai-summary-list-viewer {
  .milkdown .milkdown-list-item-block {
    border-bottom: 1px solid var(--field-borders);
    padding: 10px 0;
    &:last-child {
      border-bottom: none;
    }
  }

  .milkdown {
    background-color: transparent;
  }

    .vc-markdown-editor__content {
        .milkdown,
        .ProseMirror {
            padding: 0;
            font-size: 14px;
        }


        ul, ol {
            margin: 0;
            padding: 0;
            list-style: none;
        }

        .list-item {

            &:last-child {
                border-bottom: none;
            }

            p {
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 12px;
                padding: 12px 0;
                margin: 0;
                line-height: 1.4;
                word-break: break-word;
            }
        }
    }


    &--numbered del {
      text-decoration: none;
      position: absolute;
      right: 0;
      margin-left: auto;
      min-width: 28px;
      padding: 2px 10px;
      border-radius: 999px;
      background-color: var(--gray-200);
      font-weight: 500;
      text-align: center;
      font-variant-numeric: tabular-nums;
    }
}
</style>
